import script from "./MemberSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberSignup.vue?vue&type=script&setup=true&lang=js"

import "./MemberSignup.vue?vue&type=style&index=0&id=56c54f82&scope=true&lang=css"

const __exports__ = script;

export default __exports__